import React from 'react';
import LandingPage from '../strikegames/LandingPage';
import RegisterPage from './RegisterPage';

const RegisterWrapper: React.FC<{ referalCode?: string }> = ({ referalCode }) => {
  return (
    <div className="relative w-full h-screen overflow-hidden">
      {/* Foreground - Register */}
      <div className="absolute top-0 left-0 w-full h-full z-10 flex items-center justify-center bg-black bg-opacity-75">
        <RegisterPage referalCode={referalCode} />
      </div>
    </div>
  );
};

export default RegisterWrapper;

